module.exports = __webpack_public_path__ + "static/step1-3103a41a105faba1360cd23aa665304c.png";